import {
    IGeometryModel,
    MarkerModelBase,
} from '@types-custom/models/business/marker.model';

export interface IPropsAirQualityModel {
    stationType     : string;
    id              : string,
    location        : string,
    temperature     : string,
    humidity        : string,
    pressure        : string
    title           : string;
    lastModification: string;
    markerPopupText : string;
    icon            : unknown;
    type            : number;
    postal_code     : string;
    name            : string;
    carbonDioxide   : string;
    psi: string;
    pm10: string;
    pm25: string;
    no2: string;
    o3: string;
    so2: string; 
}

export class AirQualityModel extends MarkerModelBase {
    static className = 'AirQualityModel';
    classProperties: IPropsAirQualityModel;

    constructor(props: IPropsAirQualityModel, geometry: IGeometryModel) {
        super(geometry, AirQualityModel.className);
        this.classProperties = props;
    }
}
